export default function SettingsSavedNotice({ variant = "toast", message = "Settings saved" }) {
  const className = variant === "inline" ? "account-notice" : "account-toast";

  return (
    <div className={className} aria-live="polite">
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          flexWrap: "wrap"
        }}
      >
        <span
          aria-hidden="true"
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#15803d",
            transform: "translateY(1px)",
            flex: "0 0 auto"
          }}
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path
              d="M11.667 3.5L5.25 9.917L2.333 7"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span>{message}</span>
      </span>
    </div>
  );
}